<template>
  <processed-image
    class="avatar"
    :src="avatarSrc"
    :transforms="transforms"
    :width="width"
    :height="height"
    :alt="avatarAltTag"
    role="presentation"
    @error="handleError"
  />
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { __ } from 'bits/intl'
import ProcessedImage from 'vuecomponents/processed_image'

const ANONYMOUS_AVATAR = 'https://storage.googleapis.com/padlet-assets/image/alien_avatar.png'

export default {
  components: { ProcessedImage },
  props: ['user', 'width', 'height'],
  data() {
    return {
      hasError: false,
    }
  },
  computed: {
    avatarSrc() {
      if (this.hasError) {
        return ANONYMOUS_AVATAR
      }
      return this.user ? this.user.avatar : ANONYMOUS_AVATAR
    },
    avatarAltTag() {
      if (this.user) {
        return __('Avatar of %{name}', { name: this.user.name || this.user.username })
      }
      return __('Avatar of anonymous')
    },
    transforms() {
      if (this.width && this.height) {
        return {
          width: this.width,
          height: this.height,
          preset: 'avatar',
        }
      }
      return {
        preset: 'avatar',
      }
    },
  },
  methods: {
    handleError() {
      this.hasError = true
    },
  },
}
</script>

<style>
.avatar {
  border-radius: 96px;
}
</style>
